import React, { useEffect } from "react";
import { useForm } from "react-hook-form";

import { P } from "../../atoms/Texts";
import { DarkFormField, DarkTextArea } from "../../atoms/Inputs";
import { NewProgramFooter } from "../../organisms/Footers/footer.new.program";

const EditProgramFormOne = ({
  changeStep,
  discard,
  fields,
  updateFields,
  saveToDraft,
}) => {
  const defaultVals = {
    name: fields.name || "",
    status: fields.status || "",
    alternateName: fields.alternateName || "",
    url: fields.url || "",
    description: fields.description || "",
    email: fields.email || "",
    interpretationServices: fields.interpretationServices || "",
    applicationProcess: fields.applicationProcess || "",
    waitTime: fields.waitTime || "",
    cost: fields.cost || "",
    overallCapacity: fields.overallCapacity || "",
    currentlyServing: fields.currentlyServing || "",
  };

  const {
    register,
    handleSubmit,
    getValues,
    formState: { errors },
    reset,
  } = useForm();

  useEffect(() => {
    if (fields) {
      reset(defaultVals);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [fields]);

  const updateData = (data) => {
    updateFields(data);
    changeStep(2);
  };

  return (
    <main className="">
      <form onSubmit={handleSubmit(updateData)}>
        <section className="pb-10 w-8/12 organization-container">
          {/* Name */}
          <div>
            <DarkFormField
              type="text"
              id="name"
              name="name"
              placeholder=""
              label="Service Name"
              containerClass="flex-grow"
              {...register("name", {})}
            />

            {errors.name && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.name.message}
              </P>
            )}
          </div>

          {/* Status */}
          <div>
            <DarkFormField
              type="text"
              id="status"
              name="status"
              {...register("status")}
              placeholder=""
              label="Service Status"
              containerClass="flex-grow"
            />
          </div>

          {/* Alternate Name */}
          <div>
            <DarkFormField
              type="text"
              id="alternateName"
              name="alternateName"
              {...register("alternateName")}
              placeholder=""
              label="Alternate Name"
              containerClass="flex-grow"
            />
          </div>

          {/* Description */}
          <div>
            <DarkTextArea
              rows={3}
              id="description"
              name="description"
              placeholder="Describe the service, this helps explain what the service is about..."
              label="Description"
              className="w-full"
              {...register("description", {})}
            />

            {errors.description && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.description.message}
              </P>
            )}
          </div>

          {/* Website */}
          <div>
            <DarkFormField
              type="url"
              id="url"
              name="url"
              placeholder="e.g https://example.com"
              label="Website"
              containerClass="flex-grow"
              {...register("url", {})}
            />
            {errors.url && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.url.message}
              </P>
            )}
          </div>

          {/* Email */}
          <div>
            <DarkFormField
              type="email"
              id="email"
              name="email"
              placeholder="example@mail.com"
              label="Email"
              containerClass="flex-grow"
              required
              {...register("email", {})}
            />
            {errors.email && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.email.message}
              </P>
            )}
          </div>

          {/* Interpretation Service */}
          <div>
            <DarkTextArea
              rows={3}
              id="interpretationServices"
              name="interpretationServices"
              placeholder="What languages do you interpret?"
              label="Interpretation Service"
              containerClass="flex-grow"
              required
              {...register("interpretationServices", {})}
            />

            {errors.interpretationServices && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.interpretationServices.message}
              </P>
            )}
          </div>

          {/* Application Process */}
          <div>
            <DarkTextArea
              rows={3}
              id="applicationProcess"
              name="applicationProcess"
              placeholder="Explain the application stages..."
              label="Application Process"
              containerClass="flex-grow"
              required
              {...register("applicationProcess", {})}
            />

            {errors.applicationProcess && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.applicationProcess.message}
              </P>
            )}
          </div>

          {/* Wait time */}
          <div>
            <DarkFormField
              type="text"
              id="waitTime"
              name="waitTime"
              placeholder="e.g 1 day"
              label="Wait Time"
              containerClass="flex-grow"
              required
              {...register("waitTime", {})}
            />

            {errors.waitTime && (
              <P fontSize="12px" className="-mt-4 mb-4 text-red-400 text-sm">
                {errors.waitTime.message}
              </P>
            )}
          </div>

          {/* Cost */}
          <div>
            <DarkFormField
              type="text"
              id="cost"
              name="cost"
              placeholder="e.g USD 500.12"
              label="Cost"
              containerClass="flex-grow"
              {...register("cost")}
            />
          </div>

          {/* Overall Capacity */}
          <div>
            <DarkFormField
              type="number"
              id="overallCapacity"
              name="overallCapacity"
              placeholder=""
              label="Overall Capacity"
              containerClass="flex-grow"
              {...register("overallCapacity")}
            />
          </div>

          {/* Currently Serving */}
          <div>
            <DarkFormField
              type="number"
              id="currentlyServing"
              name="currentlyServing"
              placeholder=""
              label="Currently Serving"
              containerClass="flex-grow"
              {...register("currentlyServing")}
            />
          </div>
        </section>

        <NewProgramFooter
          changeStep={updateFields}
          updateFields={updateFields}
          discard={discard}
          saveToDraft={() => {
            const values = getValues();
            saveToDraft(values);
          }}
        />
      </form>
    </main>
  );
};

export default EditProgramFormOne;
